import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TrapActivationHistory } from 'api/traps/types';
import CellWithStatusHistory from 'components/DevicesDetail/MCT/HistoryTable/CellWithStatus';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface TrapHistoryExpandableProps {
  data: TrapActivationHistory;
  slug?: string;
}
const TrapHistoryExpandable: React.FC<TrapHistoryExpandableProps> = ({ data }) => {
  const { t } = useTranslation();

  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);
  const largeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2 mx-3">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.status')}</span>
          </div>
          <div>
            <CellWithStatusHistory {...data} />{' '}
          </div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-lg-row  my-2">
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.enter')}</span>
            </div>
            <div className="d-flex align-items-center">
              <div>{data.enter}</div>
              <div>
                {data.enter === 'L' ? <i className="ri-arrow-left-line" /> : <i className="ri-arrow-right-line" />}
              </div>
            </div>
          </div>
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.battery')}</span>
            </div>
            <div>{data.battery_percentage}</div>
          </div>
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-lg-row  my-2">
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.token')}</span>
            </div>
            <div>{data.msg_token}</div>
          </div>
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.rrsi')}</span>
            </div>
            <div>{data.rssi}</div>
          </div>
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.snr')}</span>
            </div>
            <div>{data.snr}</div>
          </div>
        </div>
      )}

      {largeDesktop && (
        <div className="d-flex flex-lg-row  my-2">
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.comment')}</span>
            </div>
            <div>{data.comment}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrapHistoryExpandable;
